import type { GetRoadmapDetail200SummaryCreatorBasicInfo } from './getRoadmapDetail200SummaryCreatorBasicInfo';
import type { GetRoadmapDetail200SummaryCreatorSocial } from './getRoadmapDetail200SummaryCreatorSocial';

/**
 * 로드맵 생성자 정보
 */
export type GetRoadmapDetail200SummaryCreator = {
  /** 사용자 기본 정보 */
  basicInfo: GetRoadmapDetail200SummaryCreatorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetRoadmapDetail200SummaryCreatorSocial;
};
